const locale = require('./collaborationTask.i18n.json');

/*@ngInject*/
const CollaborationTaskController = function ($rootScope, $scope, $stateParams, $uibModal, $document, $window, $filter, $timeout, coreConstant,
                                              coreMediator, userRepository, collaborationMediator, modalUtil, localization, authorizationConstants, submissionTaskStatus,
                                              submissionConstant, attachmentUtil, attachmentMediator, currentUserModel) {

    $scope.taskI18n = locale;

    function resetTaskViewModel() {
        $scope.taskViewModel = {
            task: null,
            editTaskPermission: null,
            placeholderSummary: $scope.taskI18n.summary,
            placeholderDescription: $scope.taskI18n.description,
            placeholderAssignTo: $scope.taskI18n.assignTo,
            placeholderPriority: $scope.taskI18n.priority,
            placeholderRemindMe: $scope.taskI18n.remindMe,
            placeholderSetDueDate: $scope.taskI18n.setDueDate,
            placeholderReceivedDate: $scope.taskI18n.receivedDate,
            placeholderTaskDetails: $scope.taskI18n.taskDetails,
            placeholderNotes: $scope.taskI18n.notes,
            placeholderTaskResolution: $scope.taskI18n.resolutionReason,
            isResolved: false,
            canEditTask: false,
            reminderDueDate: null,
            itemsList: [],
            submissionParticipantsList: [],
            assignedToUser: null,
            dueDate: null,
            receivedDate: null,
            receivedDateMin: moment().add(-3, 'months').toDate(),
            definition: {name: '', value: ''},
            priority: null,
            details: null,
            otherSummary: null,
            originalValues: null,
            summaryOptions: [],
            attachmentTagItems: [],
            showAttachmentList: false,
            submissionAttachments: [],
            filteredItemsList : [],
            priorityOptions: [
                {
                    name: '3- High',
                    value: 3
                },
                {
                    name: '2- Medium',
                    value: 2
                },
                {
                    name: '1- Low',
                    value: 1
                }
            ],
            resolutionReasonOptions: [],
            resolutionReason: null
        };

        $scope.canCloseAttachmentList = true;
        $scope.canDisplayList = false;

        const permissions = [];
        const neededPermissions = [
            authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS,
            authorizationConstants.AUTHORIZATION_DELETE_ATTACHMENTS
        ];

        _.each(neededPermissions, function (neededPermission) {
            if (currentUserModel.hasAuthorization(neededPermission)) {
                permissions.push(neededPermission);
            }
        });
        $scope.taskViewModel.permissions = permissions;

        loadSummaryDropdown();
        $scope.taskViewModel.itemsList = [];

        loadTaskPriorityOptions();
    }

    $scope.canAddAttachment = function () {
        return (_.includes($scope.taskViewModel.permissions, authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS));
    };

    $scope.canDeleteAttachment = function () {
        return (_.includes($scope.taskViewModel.permissions, authorizationConstants.AUTHORIZATION_DELETE_ATTACHMENTS));
    };

    function loadCollaborationTask(taskId) {
        resetTaskViewModel();

        $scope.viewModel.isLoading = true;

        collaborationMediator.loadCollaborationTask(taskId).then(function (taskWrapper) {
            let taskItem = taskWrapper.Task,
                definition = (taskItem.definition && taskItem.definition.indexOf('Other') !== -1) ? 'Other' : taskItem.definition;

            $scope.taskViewModel.task = taskItem;
            $scope.taskViewModel.attachmentTagItems = _.isNil($scope.taskViewModel.task.attachmentSummaries) ? [] : $scope.taskViewModel.task.attachmentSummaries;
            _.each($scope.taskViewModel.attachmentTagItems, function(attachmentTagItem) {
                attachmentTagItem.byteCountToDisplaySize = attachmentUtil.convertAttachmentSize(attachmentTagItem.size);
            });
            $scope.taskViewModel.assignedToUser = {
                id: (taskItem.assignedToGroupId) ? taskItem.assignedToGroupId : taskItem.assignedToId,
                name: (taskItem.assignedToGroupName) ? taskItem.assignedToGroupName : taskItem.assignedToName,
                group: (taskItem.assignedToGroupId) ? 'User Groups' : null
            };
            if (!$scope.taskViewModel.assignedToUser.roles) {
                $scope.getUserRoles($scope.taskViewModel.assignedToUser);
            }
            $scope.taskViewModel.originalValues = _.clone(taskItem);
            $scope.taskViewModel.dueDate = (taskItem.dueDate) ? moment(taskItem.dueDate) : null;
            $scope.taskViewModel.receivedDate = (taskItem.receivedDate) ? moment(taskItem.receivedDate) : null;
            $scope.taskViewModel.reminderDueDate = (taskItem.reminderDueDate) ? moment(taskItem.reminderDueDate) : null;
            $scope.taskViewModel.otherSummary = (definition === 'Other') ? _.replace(_.replace(taskItem.definition, 'Other::', ''), 'Other - ', '') : null;
            $scope.taskViewModel.details = taskItem.details;
            $scope.taskViewModel.definition = {
                name: definition,
                value: definition
            };
            $scope.taskViewModel.priority = (taskItem.priority) ? _.find($scope.taskViewModel.priorityOptions, ['value', taskItem.priority]) : null;
            $scope.taskViewModel.resolutionReason = {
                name: taskItem.resolutionReason,
                value: taskItem.resolutionReason
            };

            $scope.taskViewModel.editTaskPermission = $scope.canAssignTask();
            $scope.taskViewModel.isResolved = taskItem.status === submissionTaskStatus.RESOLVED;
            $scope.taskViewModel.canEditTask = !$scope.isAgent() || ($scope.isAgent() && (taskItem.assignedToId === $scope.viewModel.currentUserId));

            $scope.viewModel.isLoading = false;
            $scope.viewModel.task.isVisible = true;

            loadSubmissionAttachment();
            loadTaskResolutionReasonsDropdown();
        });
    }

    function loadTaskPriorityOptions() {
        let ownerUri = $scope.taskViewModel.task ? ('com.firstbest.underwriting.submission.task.SubmissionTask:' + $scope.taskViewModel.task.id) : null;
        const taskPriorityParams = {
            name: 'Task Priority',
            submissionUri: 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId,
            ownerUri: ownerUri
        };
        coreMediator.getDynamicDataSetItems(taskPriorityParams).then(function (result) {
          if (result) {
            _.each(result, function(option) {
                option.value = parseInt(option.value);
            });
            $scope.taskViewModel.priorityOptions = result;
          }
        });
    };

    function loadSummaryDropdown() {
        let taskSummaryParams = {
            name: 'Dynamic Task Summary for UW Advanced Filter',
            submissionUri: 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId
        };

        coreMediator.getDynamicDataSetItems(taskSummaryParams).then(function (result) {
            $scope.taskViewModel.summaryOptions = result;
        });
    }

    function loadPeoplePicker() {
        let submissionParticipantsListLength = 0;
        coreMediator.loadUsersList($stateParams.submissionId).then(function (users) {
            $scope.taskViewModel.itemsList = users;
            const submissionParticipants =  users.filter(function(user) {
                return user.group === 'Submission Participants';
            });
            $scope.taskViewModel.submissionParticipantsList = submissionParticipants;
            submissionParticipantsListLength = $scope.taskViewModel.submissionParticipantsList.length;
            $scope.taskViewModel.submissionParticipantsList.push({id: submissionParticipantsListLength, name: $scope.taskI18n.longListMessage, disabled: true });
        });
    }

    $scope.getUserRoles = function (item) {
        if (item.group!=="User Groups") {
            userRepository.getUserRolesById(item.id).then(function(roles) {
                item.roles = roles;
            });
        }
        else {
            item.roles = "User Group";
        }
    };

    function loadTaskResolutionReasonsDropdown() {
        const taskResolutionReasonsParams = {
            name: 'Task Resolution Reasons',
            submissionUri: 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId,
            ownerUri: 'com.firstbest.underwriting.submission.task.SubmissionTask:' + $scope.taskViewModel.task.id
        };

        coreMediator.getDynamicDataSetItems(taskResolutionReasonsParams).then(function (result) {
            $scope.taskViewModel.resolutionReasonOptions = result;
            // if the currently set taskResolution is not in the list of returned Task Resolution Reasons, then clear it out and update the task
            if ($scope.taskViewModel.resolutionReason != null &&
                !result.find((resolutionReasonOption) => resolutionReasonOption.name === $scope.taskViewModel.resolutionReason.name )) {
                $scope.taskViewModel.resolutionReason = null;
                $scope.handleUpdateTask();
            }
        });
    }

    $scope.filterItems = function (searchText) {
        let filteredItemsList = [],
        listItemsLength = $scope.taskViewModel.itemsList.length;
        const maxItems = 150;

        if (!_.isEmpty(searchText)) {
                filteredItemsList = _.filter($scope.taskViewModel.itemsList, function (item) {
                    return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
                });
                //if after searching there are over 150 participants - still only display submissionParticipants
                if (filteredItemsList.length > maxItems) {
                    filteredItemsList = $scope.taskViewModel.submissionParticipantsList;
                }
        } else {
            if (listItemsLength > maxItems) {
                filteredItemsList = $scope.taskViewModel.submissionParticipantsList;
            }else {
                filteredItemsList = $scope.taskViewModel.itemsList;
            }
        }

        $scope.taskViewModel.filteredItemsList = filteredItemsList;

    };

    function loadSubmissionAttachment() {

        if ($scope.isAgent()) {
            collaborationMediator.loadSharedSubmissionAttachments($stateParams.submissionId).then(function (submissionAttachmentList) {
                loadSubmissionAttachmentContinue(submissionAttachmentList);
            });
        } else {
            collaborationMediator.loadSubmissionAttachments($stateParams.submissionId).then(function (submissionAttachmentList) {
                loadSubmissionAttachmentContinue(submissionAttachmentList);
            });
        }
    }

    function loadSubmissionAttachmentContinue(submissionAttachmentList) {
        _.each(submissionAttachmentList, (attachment) => {
            _.each($scope.taskViewModel.attachmentTagItems, function (att) {
                if (att.name === attachment.name) {
                    attachment.checked = true;
                    $scope.taskViewModel.submissionAttachments.push(attachment);
                }
            });
            if (!attachment.checked) {
                $scope.taskViewModel.submissionAttachments.push(attachment);
            }
        });
    }

    $scope.isCurrentUser = function () {
        if ($scope.viewModel.userProfile && $scope.taskViewModel.task) {
            if ($scope.viewModel.currentUserId === $scope.taskViewModel.task.userId) {
                return true;
            }
        }
        return false;
    };

    $scope.isAgent = function () {
        let currentUser;
        if ($scope.getCurrentUser) {
            currentUser = $scope.getCurrentUser();
        }
        return currentUser && currentUser.userType === 'Agent';
    };

    $scope.canEditTask = function () {
        return $scope.taskViewModel.editTaskPermission;
    };

    $scope.canResolve = function () {
        return $scope.taskViewModel.editTaskPermission;
    };

    $scope.getUserId = function (item) {
        return _.isNumber(item.id) ? item.id : 0;
    };

    $scope.hideTasksSubPage = function () {
        $scope.hideSubPage();
        $timeout(function () {
            resetTaskViewModel();
        }, 500);
    };

    $scope.getPriorityName = function (priority) {
        let priorityObject = _.find($scope.taskViewModel.priorityOptions, ['value', priority]);
        return priorityObject.name;
    };

    $scope.handleAssignToChange = function () {
        if ($scope.taskViewModel.assignedToUser) {
            if ($scope.taskViewModel.assignedToUser.group === 'User Groups') {
                $scope.taskViewModel.task.assignedToId = null;
                $scope.taskViewModel.task.assignedToName = null;
                $scope.taskViewModel.task.assignedToGroupId = $scope.taskViewModel.assignedToUser.id;
                $scope.taskViewModel.task.assignedToGroupName = $scope.taskViewModel.assignedToUser.name;
            } else {
                $scope.taskViewModel.task.assignedToId = $scope.taskViewModel.assignedToUser.id;
                $scope.taskViewModel.task.assignedToName = $scope.taskViewModel.assignedToUser.name;
                $scope.taskViewModel.task.assignedToGroupId = null;
                $scope.taskViewModel.task.assignedToGroupName = null;
            }
        } else {
            $scope.taskViewModel.task.assignedToId = null;
            $scope.taskViewModel.task.assignedToName = null;
            $scope.taskViewModel.task.assignedToGroupId = null;
            $scope.taskViewModel.task.assignedToGroupName = null;
        }

        if (!$scope.taskViewModel.assignedToUser.roles) {
            $scope.getUserRoles($scope.taskViewModel.assignedToUser);
        }

        $scope.handleUpdateTask();
    };

    $scope.handleSummaryChange = function () {
        if ($scope.taskViewModel.definition.value !== $scope.taskViewModel.originalValues.definition) {
            if ($scope.taskViewModel.definition.value !== 'Other') {
                $scope.taskViewModel.task.definition = $scope.taskViewModel.definition.value;
                $scope.taskViewModel.otherSummary = null;

                $scope.handleUpdateTask().then(() => {
                    // reload task resolution reason as it is dynamic drop down based on the task definition
                    loadTaskResolutionReasonsDropdown();
                });
                $scope.taskViewModel.originalValues.definition = $scope.taskViewModel.task.definition;
            } else {
                $scope.taskViewModel.task.definition = null;
                $scope.taskViewModel.otherSummary = null;
            }
        }
    };

    $scope.handlePriorityChange = function () {
        if ($scope.taskViewModel.priority.value !== $scope.taskViewModel.originalValues.priority) {
            $scope.taskViewModel.task.priority = $scope.taskViewModel.priority.value;
            $scope.handleUpdateTask();
            $scope.taskViewModel.originalValues.priority = $scope.taskViewModel.task.priority;
        }
    };

    $scope.handleSummaryDescriptionChange = function () {
        if ($scope.taskViewModel.definition.value === 'Other' && $scope.taskViewModel.otherSummary) {
            $scope.taskViewModel.task.definition = 'Other::' + $scope.taskViewModel.otherSummary;

            $scope.handleUpdateTask();
            $scope.taskViewModel.originalValues.definition = $scope.taskViewModel.task.definition;
        } else {
            $scope.taskViewModel.task.definition = null;
        }
    };

    $scope.handleDetailsChange = function () {
        if ($scope.taskViewModel.task.details !== $scope.taskViewModel.originalValues.details) {
            $scope.handleUpdateTask();
            $scope.taskViewModel.originalValues.details = $scope.taskViewModel.task.details;
        }
    };

    $scope.handleCommentsChange = function () {
        if ($scope.taskViewModel.task.comments !== $scope.taskViewModel.originalValues.comments) {
            $scope.handleUpdateTask();
            $scope.taskViewModel.originalValues.comments = $scope.taskViewModel.task.comments;
        }
    };

    $scope.handleReceivedDateChange = function (selectedDate) {
        let receivedDate = (selectedDate) ? moment(new Date(selectedDate)).startOf('minute') : null;
        $scope.taskViewModel.task.receivedDate = (receivedDate) ? (moment(receivedDate).unix() * 1000) : null;

        $scope.handleUpdateTask();
    };

    $scope.handleDueDateChange = function (selectedDate) {
        let dueDate = (selectedDate) ? moment(new Date(selectedDate)).startOf('minute') : null,
            eightAM = (selectedDate) ? moment(selectedDate).startOf('day').add(8, 'hours') : null;

        $scope.taskViewModel.task.dueDate = (dueDate) ? (moment(dueDate).unix() * 1000) : null;
        $scope.taskViewModel.task.reminderDueDate = (eightAM) ? (moment(eightAM).unix() * 1000) : null;
        $scope.taskViewModel.reminderDueDate = eightAM;

        $scope.handleUpdateTask();
    };

    $scope.handleReminderDateChange = function (selectedDate) {
        let reminderDate = (selectedDate) ? moment(new Date(selectedDate)).startOf('minute') : null;
        $scope.taskViewModel.task.reminderDueDate = (reminderDate) ? (moment(reminderDate).unix() * 1000) : null;

        if (!reminderDate) {
            $scope.taskViewModel.task.notifyWhenPastDue = false;
        }

        $scope.handleUpdateTask();
    };

    $scope.handleResolutionReasonChange = function () {
        if ($scope.taskViewModel.resolutionReason.value !== $scope.taskViewModel.originalValues.resolutionReason) {
            $scope.taskViewModel.task.resolutionReason = $scope.taskViewModel.resolutionReason.value;
            $scope.handleUpdateTask();
            $scope.taskViewModel.originalValues.resolutionReason = $scope.taskViewModel.task.resolutionReason;
        }
    };

    $scope.handleReminderEmailClick = function () {
        $scope.taskViewModel.task.notifyWhenPastDue = !$scope.taskViewModel.task.notifyWhenPastDue;
        $scope.handleUpdateTask();
    };

    $scope.handleNextTaskClick = function () {
        $scope.taskViewModel.task.nextTask = !$scope.taskViewModel.task.nextTask;
        $scope.handleUpdateTask();
    };

    $scope.handleUpdateTask = function () {
        return $scope.updateTask($scope.taskViewModel.task.id, $scope.taskViewModel.task);
    };

    $scope.handleDeleteTask = function () {
        let taskId = $scope.taskViewModel.task.id,
            message = $scope.taskI18n.confirmationTaskDelete,
            title = $scope.taskI18n.deleteTask,
            cancelButtonLabel = $scope.taskI18n.cancelActionButtonLabel,
            confirmButtonLabel = $scope.taskI18n.confirmActionButtonLabel;

        function handleClose() {
            $scope.deleteTask(taskId);
            $scope.hideTasksSubPage();
        }

        modalUtil.showGenericConfirm({
            cancelButtonLabel: cancelButtonLabel,
            confirmActionButtonLabel: confirmButtonLabel,
            summary: message,
            title: title
        }).then(handleClose);
    };

    $scope.handleNotify = function () {
        collaborationMediator.notifyTaskAssignee($scope.taskViewModel.task.id).then(() => {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, $scope.taskI18n.taskNotifyFadingNotification);
        });
    };

    $scope.handleResolveTask = function () {
        $scope.taskViewModel.task.status = submissionTaskStatus.RESOLVED;

        $scope.updateTask($scope.taskViewModel.task.id, $scope.taskViewModel.task);
        $scope.hideTasksSubPage();
    };

    $scope.handleAttachmentDownloadClick = (attachmentItem) => {
        attachmentUtil.getAttachmentLinkURL(attachmentItem.id, attachmentItem.name).then((url) => {
            $window.open(url, '_blank');
        });
    };

    $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, () => {
        if ($scope.viewModel.task.isVisible) {
            loadPeoplePicker();
            this.filterItems();
        }
    });

    $scope.$watch('viewModel.task.isVisible', function (newValue) {
        if (newValue) {
          loadPeoplePicker();
        }
    });

    $scope.$watch('viewModel.selectedItem', function (newValue) {
        if (newValue && newValue.type === 'task') {
            loadCollaborationTask(newValue.id);
        }
    });

    $scope.openAttachmentList = function (event) {
        if ($scope.taskViewModel.submissionAttachments.length > 0) {
            $scope.canDisplayList = !$scope.canDisplayList;
            addListeners();
        } else {
            $scope.handleAttachmentClick();
        }
    };

    $scope.handleAttachmentClick = function () {
        const instance = $uibModal.open({
            templateUrl: '/collaboration/task/newTaskAttachmentModal/newTaskAttachmentModal.tpl.html',
            controller: 'newTaskAttachmentModalController',
            backdrop: 'static',
            windowClass: 'newTaskAttachmentModal',
            resolve: {
                options: function () {
                    return {};
                },
                isUnderwriterUser: !$scope.isAgent()
            }
        });
        instance.result.then(function (data) {
            let payload = attachmentUtil.getAttachmentPayload(data.attachment);
            payload = _.assign(payload, {
                'ownerUri': 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId,
                'submissionId': $stateParams.submissionId
            });

            attachmentMediator.saveAttachment(payload, data.file).then((payload) => {
                $scope.taskViewModel.submissionAttachments.push(payload.attachment);
                payload.attachment.checked = true;
                $scope.taskViewModel.attachmentTagItems.push(payload.attachment);
                $scope.taskViewModel.task.attachmentSummaries = $scope.taskViewModel.attachmentTagItems;
                collaborationMediator.updateCollaborationTaskAttachment($scope.taskViewModel.task.id, payload.attachment).then(function () {
                    $scope.handleUpdateTask();
                });
            });
        });
    };

    $scope.onAttachmentListClick = function (event) {
        $scope.canCloseAttachmentList = false;
    };

    $scope.isAttachmentSelected = function (attachment) {
        _.each($scope.taskViewModel.attachmentTagItems, function (tag) {
            if (tag.id === attachment.id) {
                return true;
            }
        });
        return false;
    };

    $scope.canDisplayAttachmentSection = function (attachment) {
        return $scope.taskViewModel.attachmentTagItems.length !== 0 || !($scope.taskViewModel.attachmentTagItems.length === 0 && !$scope.canAddAttachment());
    };

    $scope.onAttachmentItemClick = function (event, attachment) {
        let targetAttachment;
        _.each($scope.taskViewModel.attachmentTagItems, function (tag) {
            if (tag.id === attachment.id) {
                targetAttachment = tag;
            }
        });

        if (attachment.checked) {
            $scope.taskViewModel.attachmentTagItems.push(attachment);
            collaborationMediator.updateCollaborationTaskAttachment($scope.taskViewModel.task.id, attachment).then(function () {
                $scope.handleUpdateTask();
            });
        } else {
            if ($scope.canDeleteAttachment()) {
                _.pull($scope.taskViewModel.attachmentTagItems, targetAttachment);
                collaborationMediator.deleteCollaborationTaskAttachment($scope.taskViewModel.task.id, attachment.id).then(function () {
                    $scope.handleUpdateTask();
                });
            } else {
                attachment.checked = true;
            }
        }
    };

    $scope.onDeleteAttachment = function (tag) {
        _.each($scope.taskViewModel.submissionAttachments, function (attachment) {
            if (tag.id === attachment.id) {
                attachment.checked = false;
            }
        });

        collaborationMediator.deleteCollaborationTaskAttachment($scope.taskViewModel.task.id, tag.id).then(function () {
            $scope.handleUpdateTask();
        });
    };

    $scope.onUploadNewFileBlur = function () {
        handleDocumentInteraction();
    };

    function handleDocumentInteraction() {
        $timeout(function () {
            if ($scope.canCloseAttachmentList) {
                if ($scope.canDisplayList) {
                    $scope.taskViewModel.showAttachmentList = !$scope.taskViewModel.showAttachmentList;
                } else {
                    $scope.taskViewModel.showAttachmentList = false;
                    removeListeners();
                }
                $scope.canDisplayList = false;
            }
            $scope.canCloseAttachmentList = true;
        }, 0);
    }

    function addListeners() {
        $document.on('click', handleDocumentInteraction);
    }

    function removeListeners() {
        $document.off('click', handleDocumentInteraction);
    }

    resetTaskViewModel();
};

angular.module('gw-um-submission')
    .controller('collaborationTaskController', CollaborationTaskController);
